export default __webpack_public_path__ + "static/logo-4e3dc58db12f7b1ab3ef5cc966fdb249.svg";